import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

import appState from 'hooks/appState';
import { APP_STATE } from 'types';
import Slider from 'components/Slider';
import VehicleSliderCard from 'components/VehicleSliderCard';
import { routesPath } from 'utils/constants/routePath';
import { anonymousClickHandler } from 'utils/anonymousClickHandler';
import { PlusInCircleIcon } from 'public/assets/icons';
import { openSideBarAddVehicle } from 'store/sideBarControler/actions';
import { IGarageSlider } from './IGarageSlider';

import {
  AddVehicleBlock,
  GarageSliderContainer,
  GarageSliderItem,
  GarageSliderWrapper,
} from './GarageSlider.styles';

const GarageSlider = ({ vehicles = [], isMe }: IGarageSlider) => {
  const router = useRouter();
  const theme: any = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const appStateAction = appState();

  const onAddVehicle = () => {
    dispatch(openSideBarAddVehicle(''));
  };
  return (
    <GarageSliderContainer isVehiclesExist={vehicles?.length > 0}>
      {isMe && (
        // <AddVehicleBlock
        //   isMe={isMe}
        //   onClick={() => anonymousClickHandler(onAddVehicle)}
        //   isVehiclesExist={vehicles?.length > 0}
        // >
        //   <PlusInCircleIcon color={theme.colors.blue} />
        //   <div style={{ marginTop: 8 }}>
        //     {t('common:add')}
        //     {vehicles?.length > 0 && <br />}
        //     {` `}
        //     {t('feed:vehicle')}
        //   </div>
        // </AddVehicleBlock>
        <AddVehicleBlock
          isMe={isMe}
          onClick={() =>
            appStateAction(APP_STATE.ADD_VEHICLE_FORM, {
              isOpen: true,
            })
          }
          isVehiclesExist={vehicles?.length > 0}
        >
          <PlusInCircleIcon color={theme.colors.blue} />
          <div style={{ marginTop: 8 }}>
            {t('common:add')}
            {vehicles?.length > 0 && <br />}
            {` `}
            {t('feed:vehicle')}
          </div>
        </AddVehicleBlock>
      )}
      <GarageSliderWrapper isMe={isMe}>
        <Slider
          superLargeDesktop={isMe ? 2 : 3}
          desktop={isMe ? 2 : 3}
          tablet={2}
          mobile={1}
          isVehicle
        >
          {vehicles?.map((item: any) => (
            <GarageSliderItem
              key={item?._id}
              onClick={() =>
                router.push(`${routesPath.vehicle_details}/${item?._id}`)
              }
            >
              <VehicleSliderCard
                id={item?._id}
                coverPhoto={item?.photos[0]}
                year={item?.year}
                make={item?.make}
                model={item?.model}
              />
            </GarageSliderItem>
          ))}
        </Slider>
      </GarageSliderWrapper>
    </GarageSliderContainer>
  );
};

export default GarageSlider;
